export const ParticlLogo = ({ height = 24 }: { height?: number }) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 51 51"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.6237 0V33.6237H16.8118V16.8118H0V0H33.6237Z"
        fill="currentColor"
      />
      <path
        d="M16.8118 33.6237H0V50.4335H16.8118V33.6237Z"
        fill="currentColor"
      />
    </svg>
  );
};
